module.exports = __webpack_public_path__ + "img/device_cover_b.687e8705.png";